import { adminRequester } from "App";
const _ = require("lodash");

export const getTaxExcelOutput = ({
  extraCondition,
  searchCondition,
  onSuccess,
}) => {
  const outputHeader = [
    {
      text: "전자(세금)계산서 종류(01:일반, 02:영세율)",
      Cell: () => `01`,
      style: {
        common: {
          fill: {
            fgColor: { rgb: "FFCC99" },
          },
        },
      },
    },
    {
      text: "작성일자",
      code: "created_at",
      Cell: ({ cell }) => {
        return cell.split("T")[0].replaceAll("-", "");
      },
      style: {
        col: {
          alignment: { horizontal: "right" },
        },
        common: {
          fill: {
            fgColor: { rgb: "FFCC99" },
          },
        },
      },
    },
    {
      text: "공급자 등록번호(- 없이 입력)",
      Cell: () => "3218101981",
      style: {
        col: {
          alignment: { horizontal: "right" },
        },
        common: {
          fill: {
            fgColor: { rgb: "FFCC99" },
          },
        },
      },
    },
    {
      text: "공급자 종사업장번호",
    },
    {
      text: "공급자 상호",
      Cell: () => "주식회사 월드인터네셔널",
      style: {
        common: {
          fill: {
            fgColor: { rgb: "FFCC99" },
          },
        },
      },
    },
    {
      text: "공급자 성명",
      Cell: () => "원태범",
      style: {
        common: {
          fill: {
            fgColor: { rgb: "FFCC99" },
          },
        },
      },
    },
    {
      text: "공급자 사업장주소",
      Cell: () => "대전광역시 서구 관저중로95번길 68(관저동, 월드빌딩)",
    },
    {
      text: "공급자 업태",
      Cell: () => "도매 및 소매업",
    },
    {
      text: "공급자 종목",
      Cell: () => "생활용품",
    },
    {
      text: "공급자 이메일",
    },
    {
      text: "공급받는자 등록번호(- 없이 입력)",
      code: "customer",
      Cell: ({ cell }) => cell.businessNumber?.replaceAll("-", ""),
      style: {
        col: {
          alignment: { horizontal: "right" },
        },
        common: {
          fill: {
            fgColor: { rgb: "FFCC99" },
          },
        },
      },
    },
    {
      text: "공급받는자 종사업장번호",
    },
    {
      text: "공급받는자 상호",
      code: "customer",
      Cell: ({ cell }) => `${cell.businessMutual}`,
      style: {
        common: {
          fill: {
            fgColor: { rgb: "FFCC99" },
          },
        },
      },
    },
    {
      text: "공급받는자 성명",
      code: "customer",
      Cell: ({ cell }) => cell.businessName,
      style: {
        common: {
          fill: {
            fgColor: { rgb: "FFCC99" },
          },
        },
      },
    },
    {
      text: "공급받는자 사업장주소",
      code: "customer",
      Cell: ({ cell }) => (cell?.businessAddress ? cell.businessAddress : ""),
    },
    {
      text: "공급받는자 업태",
      code: "customer",
      Cell: ({ cell }) => (cell?.businessType ? cell.businessType : ""),
    },
    {
      text: "공급받는자 종목",
      code: "customer",
      Cell: ({ cell }) => (cell?.businessDetail ? cell.businessDetail : ""),
    },
    {
      text: "공급받는자 이메일1",
      code: "customer",
      Cell: ({ cell }) => (cell?.businessEmail ? cell.businessEmail : ""),
    },
    {
      text: "공급받는자 이메일2",
    },
    {
      text: "공급가액",
      code: "payments",
      Cell: ({ cell }) =>
        cell?.length > 0 && cell?.[cell?.length - 1]
          ? Math.ceil(cell[cell.length - 1]?.amount / 1.1)
          : 0,
      style: {
        col: {
          alignment: { horizontal: "right" },
        },
        common: {
          fill: {
            fgColor: { rgb: "FFCC99" },
          },
        },
      },
    },
    {
      text: "세액",
      code: "payments",
      Cell: ({ cell }) =>
        cell?.length > 0 && cell?.[cell?.length - 1]
          ? cell[cell.length - 1]?.amount -
            Math.ceil(cell[cell.length - 1]?.amount / 1.1)
          : 0,
      style: {
        col: {
          alignment: { horizontal: "right" },
        },
        common: {
          fill: {
            fgColor: { rgb: "FFCC99" },
          },
        },
      },
    },
    {
      text: "비고",
    },
    {
      text: "일자1(2자리, 작성년월 제외)",
      code: "created_at",
      Cell: ({ cell }) => {
        return cell
          .split("T")[0]
          .replaceAll("-", "")
          .slice(6);
      },
      style: {
        col: {
          alignment: { horizontal: "right" },
        },
        common: {
          fill: {
            fgColor: { rgb: "FFCC99" },
          },
        },
      },
    },
    {
      text: "품목1",
      Cell: () => "상품",
    },
    {
      text: "규격1",
    },
    {
      text: "수량1",
    },
    {
      text: "단가1",
    },
    {
      text: "공급가액1",
      code: "payments",
      Cell: ({ cell }) =>
        cell?.length > 0 && cell?.[cell?.length - 1]
          ? Math.ceil(cell[cell.length - 1]?.amount / 1.1)
          : 0,
      style: {
        col: {
          alignment: { horizontal: "right" },
        },
        common: {
          fill: {
            fgColor: { rgb: "FFCC99" },
          },
        },
      },
    },
    {
      text: "세액1",
      code: "payments",
      Cell: ({ cell }) =>
        cell?.length > 0 && cell?.[cell?.length - 1]
          ? Math.ceil(cell[cell.length - 1]?.amount / 1.1)
          : 0,
      style: {
        col: {
          alignment: { horizontal: "right" },
        },
        common: {
          fill: {
            fgColor: { rgb: "FFCC99" },
          },
        },
      },
    },
    {
      text: "품목비고1",
    },
    {
      text: "일자2(2자리, 작성년월 제외)",
    },
    {
      text: "품목2",
    },
    {
      text: "규격2",
    },
    {
      text: "수량2",
    },
    {
      text: "단가2",
    },
    {
      text: "공급가액2",
    },
    {
      text: "세액2",
    },
    {
      text: "품목비고2",
    },
    {
      text: "일자3(2자리, 작성년월 제외)",
    },
    {
      text: "품목3",
    },
    {
      text: "규격3",
    },
    {
      text: "수량3",
    },
    {
      text: "단가3",
    },
    {
      text: "공급가액3",
    },
    {
      text: "세액3",
    },
    {
      text: "품목비고3",
    },
    {
      text: "일자4(2자리, 작성년월 제외)",
    },
    {
      text: "품목4",
    },
    {
      text: "규격4",
    },
    {
      text: "수량4",
    },
    {
      text: "단가4",
    },
    {
      text: "공급가액4",
    },
    {
      text: "세액4",
    },
    {
      text: "품목비고4",
    },
    {
      text: "현금",
    },
    {
      text: "수표",
    },
    {
      text: "어음",
    },
    {
      text: "외상미수금",
    },
    {
      text: "영수(01),청구(02)",
      Cell: () => "01",
      style: {
        common: {
          fill: {
            fgColor: { rgb: "FFCC99" },
          },
        },
      },
    },
  ];

  const getData = async (data, indexes) => {
    let list;
    if (!indexes || indexes.length === 0) {
      list =
        (
          await adminRequester.getOrderStatus({
            ...extraCondition,
            ...searchCondition,
          })
        ).orders || [];
    } else {
      list = indexes.map((index) => ({
        ...data[index],
        // index: index + page * limit,
      }));
    }
    list = list?.sort((o1, o2) =>
      String(o1.created_at).localeCompare(String(o2.created_at))
    );
    return {
      style: {
        header: {
          alignment: { horizontal: "center" },
          font: {
            bold: true,
          },
          border: {
            bottom: { style: "double" },
            right: { style: "thin" },
          },
          fill: {
            fgColor: { rgb: "CCFFCC" },
          },
        },
      },
      header: outputHeader,
      list: list,
      fileName: `세금계산서_${new Date().getTime()}`,
      onSuccess: async (list) => {
        const now = new Date();
        await Promise.all(
          list.map(async (order) =>
            !order?.metadata?.published?.created_at
              ? await adminRequester.updateOrderStatus(order.id, {
                  metadata: _.merge({}, order.metadata, {
                    published: { created_at: now },
                  }),
                })
              : await adminRequester.updateOrderStatus(order.id, {
                  metadata: _.merge({}, order.metadata, {
                    published: { updated_at: now },
                  }),
                })
          )
        );
        onSuccess();
      },
    };
  };
  const output = {
    empty: [{}, {}, {}, {}, {}],
    getTitle: ({ indexes }) =>
      indexes.length === 0 ? "전체 세금계산서 엑셀" : "선택 세금 계산서 엑셀",
    getData: getData,
  };
  return output;
};

export const getShipExcelOutput = ({
  extraCondition,
  searchCondition,
  onSuccess,
}) => {
  const outputHeader = [
    {
      text: "받는분성명",
      code: "shipping_address",
      Cell: ({ cell }) =>
        `${cell.first_name ? cell.first_name : ""}${
          cell.last_name ? cell.last_name : ""
        }`,
    },
    {
      text: "받는분전화번호",
      code: "shipping_address",
      Cell: ({ cell }) => (cell.phone ? cell.phone : ""),
    },
    {
      text: "받는분기타연락처",
      Cell: () => "",
    },
    {
      text: "받는분주소(전체, 분할)",
      code: "shipping_address",
      Cell: ({ cell }) =>
        cell
          ? `${cell.address_1 ? cell.address_1 : ""}${
              cell.address_1 && cell.address_2 ? " " : ""
            }${cell.address_2 ? cell.address_2 : ""}`
          : "",
    },
    {
      text: "배송메시지1",
      code: "message",
      Cell: ({ cell }) => (cell ? cell : ""),
    },
    {
      text: "고객주문번호",
      code: "id",
    },
  ];

  const getData = async (data, indexes) => {
    let list;
    if (!indexes || indexes.length === 0) {
      list =
        (
          await adminRequester.getOrderStatus({
            ...extraCondition,
            ...searchCondition,
          })
        ).orders?.sort((o1, o2) =>
          String(o1.created_at).localeCompare(String(o2.created_at))
        ) || [];
    } else {
      list = indexes
        .map((index) => ({
          ...data[index],
          // index: index + page * limit,
        }))
        ?.sort((o1, o2) =>
          String(o1.created_at).localeCompare(String(o2.created_at))
        );
    }
    return {
      style: {
        header: {
          alignment: { horizontal: "center" },
          font: {
            bold: true,
          },
          fill: {
            fgColor: { rgb: "F0F0F0" },
          },
        },
      },
      header: outputHeader,
      list: list,
      fileName: `택배양식_${new Date().getTime()}`,
      onSuccess: async (list) => {
        const now = new Date();
        await Promise.all(
          list.map(async (order) =>
            !order?.metadata?.published?.created_at
              ? await adminRequester.updateOrderStatus(order.id, {
                  metadata: _.merge({}, order.metadata, {
                    published: { created_at: now },
                  }),
                })
              : await adminRequester.updateOrderStatus(order.id, {
                  metadata: _.merge({}, order.metadata, {
                    published: { updated_at: now },
                  }),
                })
          )
        );
        onSuccess();
      },
    };
  };
  const output = {
    getTitle: ({ indexes }) =>
      indexes.length === 0 ? "전체 택배양식 엑셀" : "선택 택배양식 엑셀",
    getData: getData,
  };
  return output;
};

export const getLineItems = ({
  extraCondition,
  searchCondition,
  onSuccess,
}) => {
  const outputHeader = [
    {
      text: "주문번호",
      code: "order",
      Cell: ({ cell }) => cell.id,
    },
    {
      text: "주문상품명",
      Cell: ({ row }) => `${row.variant.product.title} ${row.variant.title}`,
    },
    {
      text: "수량",
      Cell: ({ row }) =>
        row.extra > 0 ? `${row.quantity}${` + ${row.extra}`}` : row.quantity,
    },
    {
      text: "수령인",
      code: "order",
      Cell: ({ cell }) =>
        `${
          cell.shipping_address?.first_name
            ? cell.shipping_address.first_name
            : ""
        }${
          cell.shipping_address?.last_name
            ? cell.shipping_address.last_name
            : ""
        }`,
    },
  ];

  const getData = async (data, indexes) => {
    let list;
    if (!indexes || indexes.length === 0) {
      list =
        (
          await adminRequester.getOrderStatus({
            ...extraCondition,
            ...searchCondition,
          })
        ).orders
          ?.reduce((acc, order) => {
            const items =
              order?.items
                .map((item) => ({
                  ...item,
                  order: order,
                  quantity: item.free ? 0 : item.quantity,
                  extra: item.free ? item.quantity : 0,
                  free: null,
                }))
                .reduce((acc, item) => {
                  const find = acc.find(
                    (f) => f.variant_id === item.variant_id
                  );
                  if (find) {
                    find.quantity =
                      Number(find.quantity) + Number(item.quantity);
                    find.extra = Number(find.extra) + Number(item.extra);
                    return acc;
                  }
                  return [...acc, item];
                }, []) || [];
            return [...acc, ...items];
          }, [])
          ?.sort((l1, l2) =>
            `${l1?.order?.created_at}${l1.variant.product.title}`.localeCompare(
              `${l2?.order?.created_at}${l2.variant.product.title}`
            )
          ) || [];
    } else {
      list =
        indexes
          .map((index) => ({
            ...data[index],
            // index: index + page * limit,
          }))
          ?.reduce((acc, order) => {
            const items =
              order?.items
                .map((item) => ({
                  ...item,
                  order: order,
                  quantity: item.free ? 0 : item.quantity,
                  extra: item.free ? item.quantity : 0,
                  free: null,
                }))
                .reduce((acc, item) => {
                  const find = acc.find(
                    (f) => f.variant_id === item.variant_id
                  );
                  if (find) {
                    find.quantity =
                      Number(find.quantity) + Number(item.quantity);
                    find.extra = Number(find.extra) + Number(item.extra);
                    return acc;
                  }
                  return [...acc, item];
                }, []) || [];
            return [...acc, ...items];
          }, [])
          ?.sort((l1, l2) =>
            `${l1?.order?.created_at}${l1.variant.product.title}`.localeCompare(
              `${l2?.order?.created_at}${l2.variant.product.title}`
            )
          ) || [];
    }
    return {
      style: {
        header: {
          alignment: { horizontal: "center" },
          font: {
            bold: true,
          },
          fill: {
            fgColor: { rgb: "F0F0F0" },
          },
        },
      },
      header: outputHeader,
      list: list,
      fileName: `주문서_${new Date().getTime()}`,
      onSuccess: onSuccess,
    };
  };
  const output = {
    getTitle: ({ indexes }) =>
      indexes.length === 0 ? "전체 주문서 엑셀" : "선택 주문서 엑셀",
    getData: getData,
  };
  return output;
};
export const getOrdersExcelOutput = ({
  extraCondition,
  searchCondition,
  onSuccess,
}) => {
  const outputHeader = [
    {
      text: "주문번호",
      Cell: ({ row }) => row.order.id,
    },
    {
      text: "입점업체",
      Cell: ({ row }) => row?.variant?.product?.store?.name,
    },
    {
      text: "주문금액",
      Cell: ({ row }) =>
        Number(row.order?.payments?.[0]?.amount) +
        Number(row.order?.metadata?.point || 0),
    },
    {
      text: "사용적립금",

      Cell: ({ row }) => Number(row.order?.metadata?.point || 0),
    },
    {
      text: "입금일",
      Cell: ({ row }) => getDate(row.order?.payments?.[0]?.updated_at),
    },
    {
      text: "배송일",
      Cell: ({ row }) => {
        switch (row.order?.fulfillment_status) {
          case "shipped": {
            // return getDate(row.order?.fulfillments?.[0]?.shipped_at);
            return getDate(row.order.metadata.shipping_date);
          }
          case "partially_shipped": {
            return getDate(row.order.metadata.shipping_date);
          }
          default: {
            return "미배송";
          }
        }
      },
    },
    {
      text: "브랜드",
      Cell: ({ row }) => row.variant.product.title,
    },
    {
      text: "주문상품명",
      Cell: ({ row }) =>
        `${row.variant.product.title} ${row.variant.title}${
          row.free ? " (증정)" : ""
        }`,
    },
    {
      text: "수량",
      Cell: ({ row }) => row.quantity,
    },
    {
      text: "상품가격",
      Cell: ({ row }) => row.unit_price,
    },
    {
      text: "주문자",
      Cell: ({ row }) =>
        `${row.order.customer.first_name ? row.order.customer.first_name : ""}${
          row.order.customer.first_name && row.order.customer.last_name
            ? " "
            : ""
        }${row.order.customer.last_name ? row.order.customer.last_name : ""}`,
    },
    {
      text: "수령인",
      Cell: ({ row }) =>
        `${
          row.order.shipping_address?.first_name
            ? row.order.shipping_address?.first_name
            : ""
        }${
          row.order.shipping_address?.first_name &&
          row.order.shipping_address?.last_name
            ? " "
            : ""
        }${
          row.order.shipping_address?.last_name
            ? row.order.shipping_address.last_name
            : ""
        }`,
    },
    {
      text: "우편번호",
      Cell: ({ row }) => row.order.shipping_address?.postal_code || "",
    },
    {
      text: "주소",
      Cell: ({ row }) =>
        `${
          row.order.shipping_address?.address_1
            ? row.order.shipping_address.address_1
            : ""
        }${
          row.order.shipping_address?.address_1 &&
          row.order.shipping_address?.address_2
            ? " "
            : ""
        }${
          row.order.shipping_address?.address_2
            ? row.order.shipping_address.address_2
            : ""
        }`,
    },
    {
      text: "전화번호",
      Cell: ({ row }) => row.order.shipping_address?.phone || " ",
    },
    {
      text: "회원등급",
      Cell: ({ row }) => row.order.customer.groups?.[0]?.name || "사업자회원",
    },
  ];

  const getData = async (data, indexes) => {
    let list;
    if (!indexes || indexes.length === 0) {
      list =
        (
          await adminRequester.getOrderStatus({
            ...extraCondition,
            ...searchCondition,
          })
        ).orders || [];
    } else {
      list = indexes.map((index) => ({
        ...data[index],
        // index: index + page * limit,
      }));
    }
    list = list
      .filter(
        (f) =>
          (f.status === "completed" || f.status === "pending") &&
          (f.fulfillment_status === "shipped" ||
            f.fulfillment_status === "partially_shipped") &&
          f.payment_status === "captured"
      )
      .reduce((acc, order) => {
        return [
          ...acc,
          ...order.items.map((item) => ({ ...item, order: order })),
        ];
      }, []);
    return {
      style: {
        header: {
          alignment: { horizontal: "center" },
          font: {
            bold: true,
          },
          fill: {
            fgColor: { rgb: "F0F0F0" },
          },
        },
      },
      header: outputHeader,
      list: list,
      fileName: `정산용_주문서_${new Date().getTime()}`,
      onSuccess: onSuccess(),
    };
  };
  const output = {
    getTitle: ({ indexes }) =>
      indexes.length === 0 ? "전체 정산 주문서 엑셀" : "선택 정산 주문서 엑셀",
    getData: getData,
  };
  return output;
};
const getDate = (date) => {
  date = new Date(date);
  return `${date.getFullYear()}${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}${String(date.getDate()).padStart(2, "0")}${String(
    date.getHours()
  ).padStart(2, "0")}${String(date.getMinutes()).padStart(2, "0")}${String(
    date.getSeconds()
  ).padStart(2, "0")}`;
};
